'use client';

import { ButtonProps } from '../../common/interfaces';
import { Icon } from './Icon';
import { clsx } from 'clsx';

export const Button = ({
    type = 'button',
    size = 'md',
    rounded = 'full',
    isFullwidth = false,
    isLoading = false,
    margin,
    animation,
    onClick,
    innerRef,
    children,
  }: ButtonProps) => {
  const stylesList: string[] = [
    'flex items-center justify-center transition-colors duration-500 rounded-md',
  ];

  applyStyles();

  function applyStyles(): void {
    const sizeStyle: string = getSize(size);
    const colorStyle: string = getColor();
    stylesList.push(
      sizeStyle,
      colorStyle,
      isFullwidth ? 'w-full' : '',
      animation ? `animate-${animation}` : ''
    );
  }

  function getSize(size: string): string {
    switch (size) {
      case 'xs':
        return 'px-2 h-7 text-xs';
      case 'sm':
        return 'px-2 h-8 text-sm';
      case 'lg':
        return 'px-3 h-10 text-sm';
      default:
        return 'px-2 h-9 text-sm';
    }
  }

  function getColor(): string {
    return 'bg-neutral-900 border border-transparent text-white hover:text-neutral-900 hover:bg-white hover:border-neutral-900'
  }

  return (
    <button
      ref={innerRef}
      type={type}
      onClick={onClick}
      className={clsx(stylesList, margin, `rounded-${rounded}`)}
    >
      {isLoading && <Icon prefix="far" icon="spinner-third" size="lg" spin />}
      {!isLoading && children}
    </button>
  );
};
